import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../contexts/UserContext';
import './CreatorDashboard.css';

const CreatorDashboard = () => {
  const { currentUser, logout } = useUser();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleUploadClick = () => {
    navigate('/upload');
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="header-content">
          <h1>Creator Dashboard</h1>
          <p>Welcome back, {currentUser?.name || currentUser?.email || 'Creator'}!</p>
        </div>
        <button onClick={handleLogout} className="logout-btn">
          Logout
        </button>
      </div>

      <div className="dashboard-stats">
        <div className="stat-card">
          <h3>Total Videos</h3>
          <p className="stat-number">12</p>
        </div>
        <div className="stat-card">
          <h3>Total Views</h3>
          <p className="stat-number">45,234</p>
        </div>
        <div className="stat-card">
          <h3>Revenue</h3>
          <p className="stat-number">$1,234</p>
        </div>
        <div className="stat-card">
          <h3>Subscribers</h3>
          <p className="stat-number">5,678</p>
        </div>
      </div>

      <div className="quick-actions">
        <h3>Quick Actions</h3>
        <button onClick={handleUploadClick} className="action-button">
          📹 Upload New Video
        </button>
      </div>

      <div className="recent-videos">
        <h3>Recent Uploads</h3>
        <p className="placeholder-text">Your recent videos will appear here</p>
      </div>
    </div>
  );
};

export default CreatorDashboard;
